export default {
  //names
  firstName:20,
  lastName:20,
  fullName:50,
  userName:20,
  cafeName:30,
  bankName:20,
  city:10,
  ticketTitle:100,
  discountTitle:15,
  title:20,
  //phones
  mobileNumber:11,
  phoneNumber:11,
  //contacts
  instagramAccount:30,
  website:50,
  email:30,
  //others
  trackingNumber:50,
  amount:15,
  password:15,
  discountCode:15,
  default:50,
}